import DashboardApi from "./../api/dashboardApi";

export const GET_DASHBOARD_DATA_REQUEST =
  "dashboard/GET_DASHBOARD_DATA_REQUEST";
export const GET_DASHBOARD_DATA = "dashboard/GET_DASHBOARD_DATA";
export const GET_DASHBOARD_CONFIGURATION_REQUEST =
  "dashboard/GET_DASHBOARD_CONFIGURATION_REQUEST";
export const GET_DASHBOARD_CONFIGURATION =
  "dashboard/GET_DASHBOARD_CONFIGURATION";
export const GET_DASHBOARD_CONFIGURATION_ERROR =
  "dashboard/GET_DASHBOARD_CONFIGURATION_ERROR";
export const SAVE_DASHBOARD_CONFIGURATION_REQUEST =
  "dashboard/SAVE_DASHBOARD_CONFIGURATION_REQUEST";
export const SAVE_DASHBOARD_CONFIGURATION =
  "dashboard/SAVE_DASHBOARD_CONFIGURATION";

const initiaState = {
  data: {},
  configuration: {
    Usuario: "",
    Unidades: [],
    Tarjetas: [],
    IntervaloActualizacion: 5,
    RangoConsulta: 12,
    PrecioCombustible: 0
  },
  isLoading: false,
  isLoadingConfig: false,
  hasData: false,
  hasDataConfiguration: false
};

export default (state = initiaState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case GET_DASHBOARD_DATA:
      return {
        ...state,
        data: {
          ...action.data,
          ComparativaRalenti: state.data.ComparativaRalenti
            ? state.data.ComparativaRalenti
            : action.data.ComparativaRalenti
        },
        isLoading: false,
        hasData: true
      };

    case GET_DASHBOARD_CONFIGURATION_REQUEST:
      return {
        ...state,
        isLoadingConfig: true
      };

    case GET_DASHBOARD_CONFIGURATION:
      return {
        ...state,
        configuration: { ...action.data },
        isLoadingConfig: false,
        hasDataConfiguration: true
      };
    case SAVE_DASHBOARD_CONFIGURATION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SAVE_DASHBOARD_CONFIGURATION:
      return {
        ...state,
        configuration: { ...action.data },
        isLoading: false,
        hasDataConfiguration: true
      };

    default:
      return state;
  }
};

export const getDashboardData = config => {
  return dispatch => {
    dispatch({
      type: GET_DASHBOARD_DATA_REQUEST
    });

    if (process.env.NODE_ENV === "development") {
      DashboardApi.getDashboardDataFake(config)
        .then(data => {
          dispatch({
            type: GET_DASHBOARD_DATA,
            data
          });
        })
        .catch(err => {
          dispatch({
            type: GET_DASHBOARD_CONFIGURATION_ERROR
          });
          throw err;
        });
    } else {
      DashboardApi.getDashboardData(config)
        .then(data => {
          dispatch({
            type: GET_DASHBOARD_DATA,
            data
          });
        })
        .catch(err => {
          dispatch({
            type: GET_DASHBOARD_CONFIGURATION_ERROR
          });
          throw err;
        });
    }
  };
};

export const getDashboardConfiguration = () => {
  return dispatch => {
    dispatch({
      type: GET_DASHBOARD_CONFIGURATION_REQUEST
    });
    if (process.env.NODE_ENV === "development") {
      return DashboardApi.getDashboardConfigurationFake()
        .then(data => {
          dispatch({
            type: GET_DASHBOARD_CONFIGURATION,
            data
          });
        })
        .catch(err => {
          dispatch({
            type: GET_DASHBOARD_CONFIGURATION_ERROR
          });
          throw err;
        });
    } else {
      return DashboardApi.getDashboardConfiguration()
        .then(data => {
          dispatch({
            type: GET_DASHBOARD_CONFIGURATION,
            data
          });
        })
        .catch(err => {
          dispatch({
            type: GET_DASHBOARD_CONFIGURATION_ERROR
          });
          throw err;
        });
    }
  };
};

export const saveDashboardConfiguration = config => {
  return dispatch => {
    dispatch({
      type: SAVE_DASHBOARD_CONFIGURATION_REQUEST
    });
    if (process.env.NODE_ENV === "development") {
      return DashboardApi.saveDashboardConfigurationFake(config)
        .then(data => {
          dispatch({
            type: SAVE_DASHBOARD_CONFIGURATION,
            data
          });
        })
        .catch(err => {
          dispatch({
            type: GET_DASHBOARD_CONFIGURATION_ERROR
          });
          throw err;
        });
    } else {
      return DashboardApi.saveDashboardConfiguration(config)
        .then(data => {
          dispatch({
            type: SAVE_DASHBOARD_CONFIGURATION,
            data
          });
        })
        .catch(err => {
          dispatch({
            type: GET_DASHBOARD_CONFIGURATION_ERROR
          });
          throw err;
        });
    }
  };
};



// WEBPACK FOOTER //
// ./src/modules/dashboard.js